// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var $$String = require("rescript/lib/js/string.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Float = require("rescript/lib/js/belt_Float.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Belt_SetString = require("rescript/lib/js/belt_SetString.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Mode$ReactHooksTemplate = require("./mode.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var Campaign$ReactHooksTemplate = require("./campaign.res.js");
var Pagination$ReactHooksTemplate = require("../common/Pagination.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");
var CampaignForm$ReactHooksTemplate = require("./CampaignForm.res.js");
var PaginationUtils$ReactHooksTemplate = require("../common/PaginationUtils.res.js");

var initialState = {
  loading: true,
  campaigns: /* [] */0,
  campaignChangeModalToggle: false,
  outsideClick: true,
  selectedCampaign: undefined,
  formView: "CampaignNew"
};

function reducer(state, action) {
  if (typeof action !== "object") {
    if (action === "FetchCampaignsInProgress") {
      return {
              loading: true,
              campaigns: state.campaigns,
              campaignChangeModalToggle: state.campaignChangeModalToggle,
              outsideClick: state.outsideClick,
              selectedCampaign: state.selectedCampaign,
              formView: state.formView
            };
    } else {
      return {
              loading: state.loading,
              campaigns: state.campaigns,
              campaignChangeModalToggle: !state.campaignChangeModalToggle,
              outsideClick: state.outsideClick,
              selectedCampaign: state.selectedCampaign,
              formView: state.formView
            };
    }
  }
  switch (action.TAG) {
    case "FetchCampaignsCompleted" :
        return {
                loading: false,
                campaigns: action._0,
                campaignChangeModalToggle: state.campaignChangeModalToggle,
                outsideClick: state.outsideClick,
                selectedCampaign: state.selectedCampaign,
                formView: state.formView
              };
    case "SetOutsideClick" :
        return {
                loading: state.loading,
                campaigns: state.campaigns,
                campaignChangeModalToggle: state.campaignChangeModalToggle,
                outsideClick: action._0,
                selectedCampaign: state.selectedCampaign,
                formView: state.formView
              };
    case "SetCampaign" :
        var campaign = action._0;
        if (campaign !== undefined) {
          return {
                  loading: state.loading,
                  campaigns: state.campaigns,
                  campaignChangeModalToggle: state.campaignChangeModalToggle,
                  outsideClick: state.outsideClick,
                  selectedCampaign: Caml_option.some(Caml_option.valFromOption(campaign)),
                  formView: state.formView
                };
        } else {
          return {
                  loading: state.loading,
                  campaigns: state.campaigns,
                  campaignChangeModalToggle: state.campaignChangeModalToggle,
                  outsideClick: state.outsideClick,
                  selectedCampaign: undefined,
                  formView: state.formView
                };
        }
    case "SetFormView" :
        return {
                loading: state.loading,
                campaigns: state.campaigns,
                campaignChangeModalToggle: state.campaignChangeModalToggle,
                outsideClick: state.outsideClick,
                selectedCampaign: state.selectedCampaign,
                formView: action._0
              };
    
  }
}

var searchPlaceholder = "Search Campaigns";

function CampaignList(props) {
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        return PaginationUtils$ReactHooksTemplate.emptyPageInfo;
      });
  var setPageInfo = match$1[1];
  var pageInfo = match$1[0];
  var match$2 = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var match$3 = React.useState(function (param) {
        
      });
  var setSearchKey = match$3[1];
  var searchKey = match$3[0];
  var match$4 = React.useState(function (param) {
        return /* [] */0;
      });
  var setFavorites = match$4[1];
  var match$5 = React.useState(function (param) {
        
      });
  var setTriggerSummaries = match$5[1];
  var triggerSummaries = match$5[0];
  var match$6 = React.useState(function (param) {
        
      });
  var setMetricsLoadingIds = match$6[1];
  var metricsLoadingIds = match$6[0];
  var match$7 = React.useState(function (param) {
        
      });
  var setMetricsErrorIds = match$7[1];
  var metricsErrorIds = match$7[0];
  var match$8 = React.useState(function (param) {
        return 0;
      });
  var setRefreshVersion = match$8[1];
  var match$9 = React.useState(function (param) {
        return false;
      });
  var setShowFavoritesOnly = match$9[1];
  var showFavoritesOnly = match$9[0];
  var resetCampaignMetrics = function (param) {
    Curry._1(setTriggerSummaries, (function (param) {
            
          }));
    Curry._1(setMetricsLoadingIds, (function (param) {
            
          }));
    Curry._1(setMetricsErrorIds, (function (param) {
            
          }));
  };
  var fetchFavorites = function (param) {
    Js_promise.then_((function (favs) {
            Curry._1(setFavorites, (function (param) {
                    return favs;
                  }));
            return Promise.resolve();
          }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/campaigns/favorites", (function (param) {
                return Json_decode.field("campaigns", (function (param) {
                              return Json_decode.list(Campaign$ReactHooksTemplate.decode, param);
                            }), param);
              })));
  };
  React.useEffect((function (param) {
          fetchFavorites();
        }), []);
  var queryParams = Querystringify.parse(props.search);
  var x = Js_dict.get(queryParams, "page");
  var currentPage;
  if (x !== undefined && x !== "") {
    var page = Belt_Int.fromString(x);
    currentPage = page !== undefined ? page : 1;
  } else {
    currentPage = 1;
  }
  var x$1 = Js_dict.get(queryParams, "search");
  var currentSearchKey = x$1 !== undefined && x$1 !== "" ? x$1 : undefined;
  var match$10 = Js_dict.get(queryParams, "favorites");
  var currentFavoritesOnly;
  if (match$10 !== undefined) {
    switch (match$10) {
      case "1" :
      case "true" :
          currentFavoritesOnly = true;
          break;
      default:
        currentFavoritesOnly = false;
    }
  } else {
    currentFavoritesOnly = false;
  }
  var fetchDependencyKey = String(currentPage) + "|" + Belt_Option.getWithDefault(currentSearchKey, "") + "|" + (
    currentFavoritesOnly ? "1" : "0"
  ) + "|" + String(match$8[0]);
  React.useEffect((function (param) {
          Curry._1(setShowFavoritesOnly, (function (param) {
                  return currentFavoritesOnly;
                }));
        }), [currentFavoritesOnly]);
  var handleSearchKeyChange = function ($$event) {
    var value = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(setSearchKey, (function (param) {
            if (value === "") {
              return ;
            } else {
              return value;
            }
          }));
  };
  var handlePageChange = function (pageNumber) {
    var pageNumber$1 = String(pageNumber);
    if (currentFavoritesOnly) {
      if (currentSearchKey !== undefined) {
        return RescriptReactRouter.push("/campaigns/all?favorites=true&page=" + pageNumber$1 + "&search=" + currentSearchKey);
      } else {
        return RescriptReactRouter.push("/campaigns/all?favorites=true&page=" + pageNumber$1);
      }
    } else if (currentSearchKey !== undefined) {
      return RescriptReactRouter.push("/campaigns/all?page=" + pageNumber$1 + "&search=" + currentSearchKey);
    } else {
      return RescriptReactRouter.push("/campaigns/all?page=" + pageNumber$1);
    }
  };
  var decodeTriggerSummaryData = function (payload) {
    var rows = Json_decode.field("data", (function (param) {
            return Json_decode.array((function (item) {
                          var key = Json_decode.field("key", Json_decode.string, item);
                          var s = Json_decode.optional((function (param) {
                                  return Json_decode.field("score", Json_decode.string, param);
                                }), item);
                          var score;
                          if (s !== undefined) {
                            score = s;
                          } else {
                            var f = Json_decode.optional((function (param) {
                                    return Json_decode.field("score", Json_decode.$$float, param);
                                  }), item);
                            score = f !== undefined ? f.toString() : "0";
                          }
                          return [
                                  key,
                                  score
                                ];
                        }), param);
          }), payload);
    var rowDict = {};
    Belt_Array.forEach(rows, (function (param) {
            rowDict[param[0]] = param[1];
          }));
    return {
            triggers: Belt_Option.getWithDefault(Js_dict.get(rowDict, "Triggers"), "--"),
            responses: Belt_Option.getWithDefault(Js_dict.get(rowDict, "Responses"), "--"),
            responsePercentage: Belt_Option.getWithDefault(Js_dict.get(rowDict, "Response %"), "--")
          };
  };
  var fetchTriggerSummaryForCampaign = function (forceRefreshOpt, campaign) {
    var forceRefresh = forceRefreshOpt !== undefined ? forceRefreshOpt : false;
    var idKey = String(Campaign$ReactHooksTemplate.id(campaign));
    Curry._1(setMetricsLoadingIds, (function (s) {
            return Belt_SetString.add(s, idKey);
          }));
    Curry._1(setMetricsErrorIds, (function (s) {
            return Belt_SetString.remove(s, idKey);
          }));
    var cacheSuffix = forceRefresh ? "&_=" + String(Date.now()) : "";
    var url = "/api/v1/campaigns/visualization_data?name=response_percentage_card_data&campaign_id=" + idKey + cacheSuffix;
    Js_promise.$$catch((function (param) {
            Curry._1(setMetricsLoadingIds, (function (s) {
                    return Belt_SetString.remove(s, idKey);
                  }));
            Curry._1(setMetricsErrorIds, (function (s) {
                    return Belt_SetString.add(s, idKey);
                  }));
            return Promise.resolve();
          }), Js_promise.then_((function (summary) {
                Curry._1(setMetricsLoadingIds, (function (s) {
                        return Belt_SetString.remove(s, idKey);
                      }));
                Curry._1(setTriggerSummaries, (function (m) {
                        return Belt_MapString.set(m, idKey, summary);
                      }));
                return Promise.resolve();
              }), Http$ReactHooksTemplate.fetchGetJSONDecode(url, (function (payload) {
                    return Json_decode.field("visualization", decodeTriggerSummaryData, payload);
                  }))));
  };
  var toggleCampaign = function (option) {
    Curry._1(dispatch, "ToggleCampaignModal");
    if (option !== "save") {
      return ;
    }
    var url = "/api/v1/campaigns?page=" + String(currentPage);
    Curry._1(dispatch, "FetchCampaignsInProgress");
    resetCampaignMetrics();
    Js_promise.then_((function (param) {
            var headers = param[0];
            return Promise.resolve((Curry._1(setPageInfo, (function (param) {
                                return PaginationUtils$ReactHooksTemplate.fromFetchHeaders(headers);
                              })), Js_promise.then_((function (json) {
                                return Js_promise.then_((function (campaigns) {
                                              Curry._1(dispatch, {
                                                    TAG: "FetchCampaignsCompleted",
                                                    _0: campaigns
                                                  });
                                              return Promise.resolve();
                                            }), Promise.resolve(Json_decode.field("campaigns", (function (param) {
                                                      return Json_decode.list(Campaign$ReactHooksTemplate.decode, param);
                                                    }), json)));
                              }), param[1])));
          }), Http$ReactHooksTemplate.fetchGetJSONWithHeader(url));
  };
  var totalCount = Caml_format.int_of_string(pageInfo.total);
  var perPageCount = Caml_format.int_of_string(pageInfo.perPage);
  var totalPagesCount = PaginationUtils$ReactHooksTemplate.totalPages(totalCount, perPageCount);
  React.useEffect((function (param) {
          var pageNumber = String(currentPage);
          var url = currentFavoritesOnly ? (
              currentSearchKey !== undefined ? "/api/v1/campaigns?page=" + pageNumber + "&favorites=true&search=" + currentSearchKey : "/api/v1/campaigns?page=" + pageNumber + "&favorites=true"
            ) : (
              currentSearchKey !== undefined ? "/api/v1/campaigns?page=" + pageNumber + "&search=" + currentSearchKey : "/api/v1/campaigns?page=" + pageNumber
            );
          Curry._1(dispatch, "FetchCampaignsInProgress");
          resetCampaignMetrics();
          Js_promise.then_((function (param) {
                  var headers = param[0];
                  return Promise.resolve((Curry._1(setPageInfo, (function (param) {
                                      return PaginationUtils$ReactHooksTemplate.fromFetchHeaders(headers);
                                    })), Curry._1(setSearchKey, (function (param) {
                                      return currentSearchKey;
                                    })), Js_promise.then_((function (json) {
                                      return Js_promise.then_((function (campaigns) {
                                                    Curry._1(dispatch, {
                                                          TAG: "FetchCampaignsCompleted",
                                                          _0: campaigns
                                                        });
                                                    return Promise.resolve();
                                                  }), Promise.resolve(Json_decode.field("campaigns", (function (param) {
                                                            return Json_decode.list(Campaign$ReactHooksTemplate.decode, param);
                                                          }), json)));
                                    }), param[1])));
                }), Http$ReactHooksTemplate.fetchGetJSONWithHeader(url));
        }), [fetchDependencyKey]);
  var favoriteCampaignIds = Belt_List.map(match$4[0], Campaign$ReactHooksTemplate.id);
  var isFavorited = function (campaign) {
    return List.exists((function (id) {
                  return id === Campaign$ReactHooksTemplate.id(campaign);
                }), favoriteCampaignIds);
  };
  var filteredCampaigns = state.campaigns;
  var cardAccent = function (index) {
    var match = index - Math.imul(index / 3 | 0, 3) | 0;
    if (match !== 0) {
      if (match !== 1) {
        return "border-l-teal-500";
      } else {
        return "border-l-purple-500";
      }
    } else {
      return "border-l-blue-500";
    }
  };
  var campaignModeSummary = function (campaign) {
    return List.fold_left((function (acc, mode) {
                  return mode + (
                          acc !== "" ? " | " + acc : acc
                        );
                }), "", List.sort($$String.compare, List.map(Mode$ReactHooksTemplate.modeType, Campaign$ReactHooksTemplate.modes(campaign))));
  };
  var renderTriggerSummary = function (campaign) {
    var idKey = String(Campaign$ReactHooksTemplate.id(campaign));
    var metricsShell = function (children) {
      return JsxRuntime.jsx("div", {
                  children: children,
                  className: "w-full min-w-0 flex flex-col items-center justify-center gap-2 py-1"
                });
    };
    if (Belt_SetString.has(metricsLoadingIds, idKey)) {
      return metricsShell(JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              className: "w-5 h-5 flex-shrink-0 border-2 border-purple-600 border-t-transparent rounded-full animate-spin"
                            }),
                        JsxRuntime.jsx("span", {
                              children: "Loading stats...",
                              className: "text-sm text-gray-600 leading-none"
                            })
                      ],
                      className: "flex flex-row items-center justify-center gap-2"
                    }));
    }
    if (Belt_SetString.has(metricsErrorIds, idKey)) {
      return metricsShell(JsxRuntime.jsxs(JsxRuntime.Fragment, {
                      children: [
                        JsxRuntime.jsx("p", {
                              children: "Could not load stats.",
                              className: "text-xs text-red-600 text-center max-w-[280px] leading-snug"
                            }),
                        JsxRuntime.jsx("button", {
                              children: "Try again",
                              className: "inline-flex items-center justify-center px-3 py-2 rounded-xl border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 text-xs font-semibold transition",
                              type: "button",
                              onClick: (function (param) {
                                  fetchTriggerSummaryForCampaign(true, campaign);
                                })
                            })
                      ]
                    }));
    }
    var summary = Belt_MapString.get(triggerSummaries, idKey);
    if (summary === undefined) {
      return metricsShell(JsxRuntime.jsxs(JsxRuntime.Fragment, {
                      children: [
                        JsxRuntime.jsx("button", {
                              children: "Show triggers & responses",
                              className: "inline-flex w-full max-w-xs items-center justify-center px-3 py-2.5 rounded-xl border border-purple-300 text-purple-700 bg-white hover:bg-purple-50 text-xs font-semibold transition",
                              type: "button",
                              onClick: (function (param) {
                                  fetchTriggerSummaryForCampaign(undefined, campaign);
                                })
                            }),
                        JsxRuntime.jsx("p", {
                              children: "Loads metrics for this campaign only.",
                              className: "text-10-px text-gray-500 text-center max-w-xs leading-snug px-1"
                            })
                      ]
                    }));
    }
    var formatCompactNumber = function (raw) {
      var cleaned = raw.trim();
      var nOpt = Belt_Float.fromString(cleaned);
      if (nOpt === undefined) {
        return raw;
      }
      var absN = Math.abs(nOpt);
      var match = absN >= 1000000000000.0 ? [
          1000000000000.0,
          "T"
        ] : (
          absN >= 1000000000.0 ? [
              1000000000.0,
              "B"
            ] : (
              absN >= 1000000.0 ? [
                  1000000.0,
                  "M"
                ] : (
                  absN >= 1000.0 ? [
                      1000.0,
                      "K"
                    ] : [
                      1.0,
                      ""
                    ]
                )
            )
        );
      var suffix = match[1];
      var value = nOpt / match[0];
      var roundedFloat = suffix === "" ? value : (
          value >= 100.0 ? Math.round(value) : (
              value >= 10.0 ? Math.round(value * 10.0) / 10.0 : Math.round(value * 100.0) / 100.0
            )
        );
      var rounded = roundedFloat.toString();
      var rounded$1 = rounded.endsWith(".00") ? rounded.slice(0, rounded.length - 3 | 0) : (
          rounded.endsWith(".0") ? rounded.slice(0, rounded.length - 2 | 0) : rounded
        );
      return rounded$1 + suffix;
    };
    var metricCard = function (title, value, topBorderColor) {
      return JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("p", {
                          children: title,
                          className: "text-center text-10-px font-semibold uppercase tracking-wide pt-2 px-2 text-gray-600 truncate"
                        }),
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx("p", {
                                children: value,
                                className: "w-full text-center text-base sm:text-lg font-extrabold text-gray-900 leading-none tabular-nums truncate"
                              }),
                          className: "flex-1 flex items-center justify-center py-2 px-2 min-h-10"
                        })
                  ],
                  className: "w-[92px] sm:w-[110px] rounded-xl border border-gray-200 bg-white overflow-hidden shadow-sm " + topBorderColor,
                  title: title + ": " + value
                });
    };
    return metricsShell(JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              metricCard("Triggers", formatCompactNumber(summary.triggers), "border-t-2 border-t-blue-500"),
                              metricCard("Responses", formatCompactNumber(summary.responses), "border-t-2 border-t-green-500"),
                              metricCard("Response %", summary.responsePercentage, "border-t-2 border-t-purple-500")
                            ],
                            className: "flex flex-row flex-wrap items-stretch justify-center gap-2 sm:gap-3"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("button", {
                                    children: "Refresh",
                                    className: "inline-flex items-center justify-center px-3 py-2 rounded-xl border border-blue-200 text-blue-700 bg-white hover:bg-blue-50 text-xs font-semibold transition",
                                    title: "Reload latest counts from the server",
                                    type: "button",
                                    onClick: (function (param) {
                                        fetchTriggerSummaryForCampaign(true, campaign);
                                      })
                                  }),
                              JsxRuntime.jsx("button", {
                                    children: "Hide",
                                    className: "inline-flex items-center justify-center px-3 py-2 rounded-xl border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 text-xs font-semibold transition",
                                    title: "Clear metrics for this campaign",
                                    type: "button",
                                    onClick: (function (param) {
                                        var idKey = String(Campaign$ReactHooksTemplate.id(campaign));
                                        Curry._1(setTriggerSummaries, (function (m) {
                                                return Belt_MapString.remove(m, idKey);
                                              }));
                                        Curry._1(setMetricsErrorIds, (function (s) {
                                                return Belt_SetString.remove(s, idKey);
                                              }));
                                        Curry._1(setMetricsLoadingIds, (function (s) {
                                                return Belt_SetString.remove(s, idKey);
                                              }));
                                      })
                                  })
                            ],
                            className: "flex flex-row flex-wrap items-center justify-center gap-2"
                          })
                    ]
                  }));
  };
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(state.loading ? JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    className: "w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"
                                                  }),
                                              JsxRuntime.jsx("span", {
                                                    children: "Loading Campaigns...",
                                                    className: "text-gray-600"
                                                  })
                                            ],
                                            className: "flex items-center space-x-3"
                                          }),
                                      className: "flex items-center justify-center py-20"
                                    }),
                                className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
                              }),
                          className: "max-w-[1600px] mx-auto px-4 sm:px-6 py-6"
                        }) : JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("div", {
                                                              children: JsxRuntime.jsx("span", {
                                                                    children: "📊",
                                                                    className: "text-xl"
                                                                  }),
                                                              className: "flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-blue-100 to-indigo-100 shadow-sm"
                                                            }),
                                                        JsxRuntime.jsxs("div", {
                                                              children: [
                                                                JsxRuntime.jsx("h1", {
                                                                      children: "Campaigns",
                                                                      className: "text-2xl font-bold text-gray-900"
                                                                    }),
                                                                JsxRuntime.jsx("p", {
                                                                      children: "Manage all survey campaigns, distributions, and configurations in one place.",
                                                                      className: "text-sm text-gray-600 mt-1"
                                                                    })
                                                              ]
                                                            })
                                                      ],
                                                      className: "flex items-center space-x-3"
                                                    }),
                                                JsxRuntime.jsx("div", {
                                                      children: Curry._1(match$2[0], "CreateCampaign") ? JsxRuntime.jsxs("button", {
                                                              children: [
                                                                JsxRuntime.jsx("span", {
                                                                      children: "+",
                                                                      className: "mr-2"
                                                                    }),
                                                                "New Campaign"
                                                              ],
                                                              className: "inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                                              onClick: (function (param) {
                                                                  Curry._1(dispatch, {
                                                                        TAG: "SetFormView",
                                                                        _0: "CampaignNew"
                                                                      });
                                                                  Curry._1(dispatch, {
                                                                        TAG: "SetCampaign",
                                                                        _0: undefined
                                                                      });
                                                                  Curry._1(dispatch, "ToggleCampaignModal");
                                                                })
                                                            }) : null,
                                                      className: "flex justify-end"
                                                    })
                                              ],
                                              className: "flex items-center justify-between"
                                            }),
                                        className: "bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 px-5 py-4 border-b border-gray-200"
                                      }),
                                  className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden mb-4 hover:shadow-xl transition-shadow duration-300"
                                }),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          className: "px-5 pt-3 border-b border-gray-100 bg-gradient-to-r from-gray-50 to-white"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx("div", {
                                                          children: JsxRuntime.jsx("span", {
                                                                children: "🔍",
                                                                className: "text-gray-400 text-sm"
                                                              }),
                                                          className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                                                        }),
                                                    JsxRuntime.jsx("form", {
                                                          children: JsxRuntime.jsx("input", {
                                                                className: "w-full pl-9 pr-10 py-2.5 text-sm text-gray-900 placeholder-gray-400 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200",
                                                                placeholder: searchPlaceholder,
                                                                type: "text",
                                                                value: Belt_Option.getWithDefault(searchKey, ""),
                                                                onChange: handleSearchKeyChange
                                                              }),
                                                          onSubmit: (function ($$event) {
                                                              $$event.preventDefault();
                                                              var baseUrl = "/campaigns/all";
                                                              if (currentFavoritesOnly) {
                                                                if (searchKey !== undefined) {
                                                                  return RescriptReactRouter.push(baseUrl + "?favorites=true&search=" + searchKey);
                                                                } else {
                                                                  return RescriptReactRouter.push(baseUrl + "?favorites=true");
                                                                }
                                                              } else if (searchKey !== undefined) {
                                                                return RescriptReactRouter.push(baseUrl + "?search=" + searchKey);
                                                              } else {
                                                                return RescriptReactRouter.push(baseUrl);
                                                              }
                                                            })
                                                        }),
                                                    searchKey !== undefined && searchKey !== "" ? JsxRuntime.jsx("button", {
                                                            children: JsxRuntime.jsx("span", {
                                                                  children: "✕",
                                                                  className: "text-sm"
                                                                }),
                                                            className: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors duration-200",
                                                            onClick: (function (param) {
                                                                Curry._1(setSearchKey, (function (param) {
                                                                        
                                                                      }));
                                                                if (showFavoritesOnly) {
                                                                  return RescriptReactRouter.push("/campaigns/all?favorites=true");
                                                                } else {
                                                                  return RescriptReactRouter.push("/campaigns/all");
                                                                }
                                                              })
                                                          }) : null
                                                  ],
                                                  className: "relative w-full max-w-sm"
                                                }),
                                            JsxRuntime.jsx("button", {
                                                  children: "♥",
                                                  className: "inline-flex items-center justify-center h-9 w-9 rounded-lg border text-lg transition flex-shrink-0 " + (
                                                    showFavoritesOnly ? "bg-red-50 border-red-200 text-red-600" : "bg-white border-gray-200 text-gray-500 hover:bg-gray-50 hover:text-red-500"
                                                  ),
                                                  title: showFavoritesOnly ? "Showing favorites only" : "Show favorites only",
                                                  type: "button",
                                                  onClick: (function (param) {
                                                      var nextValue = !showFavoritesOnly;
                                                      Curry._1(setShowFavoritesOnly, (function (param) {
                                                              return nextValue;
                                                            }));
                                                      var baseUrl = "/campaigns/all";
                                                      if (nextValue) {
                                                        if (currentSearchKey !== undefined) {
                                                          return RescriptReactRouter.push(baseUrl + "?favorites=true&search=" + currentSearchKey);
                                                        } else {
                                                          return RescriptReactRouter.push(baseUrl + "?favorites=true");
                                                        }
                                                      } else if (currentSearchKey !== undefined) {
                                                        return RescriptReactRouter.push(baseUrl + "?search=" + currentSearchKey);
                                                      } else {
                                                        return RescriptReactRouter.push(baseUrl);
                                                      }
                                                    })
                                                })
                                          ],
                                          className: "flex justify-between px-5 pt-3 pb-3 items-center gap-4"
                                        }),
                                    JsxRuntime.jsx(Pagination$ReactHooksTemplate.Bar.make, {
                                          currentPage: currentPage,
                                          totalPages: totalPagesCount,
                                          totalRecords: totalCount,
                                          perPage: perPageCount,
                                          handlePageChange: handlePageChange,
                                          itemLabel: "campaigns",
                                          className: "mx-5 mb-4"
                                        }),
                                    JsxRuntime.jsx("div", {
                                          children: filteredCampaigns ? JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsx("div", {
                                                        children: $$Array.of_list(Belt_List.mapWithIndex(filteredCampaigns, (function (index, campaign) {
                                                                    return JsxRuntime.jsx("div", {
                                                                                children: JsxRuntime.jsxs("div", {
                                                                                      children: [
                                                                                        JsxRuntime.jsxs("div", {
                                                                                              children: [
                                                                                                JsxRuntime.jsx("div", {
                                                                                                      children: JsxRuntime.jsx("div", {
                                                                                                            children: Campaign$ReactHooksTemplate.name(campaign)[0],
                                                                                                            className: "m-auto text-sm font-bold"
                                                                                                          }),
                                                                                                      className: "w-10 h-10 flex items-center text-white uppercase rounded-2xl flex-shrink-0 shadow-sm " + Utils$ReactHooksTemplate.randomBgColor()
                                                                                                    }),
                                                                                                JsxRuntime.jsxs("div", {
                                                                                                      children: [
                                                                                                        JsxRuntime.jsxs("div", {
                                                                                                              children: [
                                                                                                                JsxRuntime.jsx("a", {
                                                                                                                      children: JsxRuntime.jsx("p", {
                                                                                                                            children: Campaign$ReactHooksTemplate.name(campaign),
                                                                                                                            className: "font-extrabold text-gray-900 truncate text-base leading-snug hover:text-blue-700 transition-colors",
                                                                                                                            title: Campaign$ReactHooksTemplate.name(campaign)
                                                                                                                          }),
                                                                                                                      className: "min-w-0 max-w-[200px] sm:max-w-[280px] lg:max-w-[320px]",
                                                                                                                      href: "/campaigns/" + (String(Campaign$ReactHooksTemplate.id(campaign)) + "/dashboard")
                                                                                                                    }),
                                                                                                                JsxRuntime.jsx("button", {
                                                                                                                      children: JsxRuntime.jsx("img", {
                                                                                                                            className: "h-4 w-4",
                                                                                                                            src: isFavorited(campaign) ? Image$ReactHooksTemplate.filledStar : Image$ReactHooksTemplate.emptyStar
                                                                                                                          }),
                                                                                                                      "aria-label": isFavorited(campaign) ? "Remove from favorites" : "Add to favorites",
                                                                                                                      className: "flex-shrink-0 p-1 rounded-md hover:bg-amber-50 text-gray-400 hover:text-amber-600 transition-colors",
                                                                                                                      title: isFavorited(campaign) ? "Remove from favorites" : "Add to favorites",
                                                                                                                      type: "button",
                                                                                                                      onClick: (function (param) {
                                                                                                                          var campaignId = Campaign$ReactHooksTemplate.id(campaign);
                                                                                                                          var url = "/api/v1/campaigns/" + String(campaignId) + "/toggle_favorite";
                                                                                                                          Js_promise.then_((function (_response) {
                                                                                                                                  fetchFavorites();
                                                                                                                                  Curry._1(setRefreshVersion, (function (v) {
                                                                                                                                          return v + 1 | 0;
                                                                                                                                        }));
                                                                                                                                  return Promise.resolve();
                                                                                                                                }), Http$ReactHooksTemplate.fetchPostJSON(url, {}));
                                                                                                                        })
                                                                                                                    })
                                                                                                              ],
                                                                                                              className: "inline-flex items-center gap-1.5 min-w-0 max-w-full"
                                                                                                            }),
                                                                                                        JsxRuntime.jsxs("div", {
                                                                                                              children: [
                                                                                                                JsxRuntime.jsxs("p", {
                                                                                                                      children: [
                                                                                                                        JsxRuntime.jsx("span", {
                                                                                                                              children: "Survey: ",
                                                                                                                              className: "font-semibold text-indigo-800"
                                                                                                                            }),
                                                                                                                        Campaign$ReactHooksTemplate.surveyName(campaign)
                                                                                                                      ],
                                                                                                                      className: "text-xs text-gray-600 truncate leading-snug",
                                                                                                                      title: Campaign$ReactHooksTemplate.surveyName(campaign)
                                                                                                                    }),
                                                                                                                JsxRuntime.jsxs("p", {
                                                                                                                      children: [
                                                                                                                        JsxRuntime.jsx("span", {
                                                                                                                              children: "Modes: ",
                                                                                                                              className: "font-semibold text-indigo-800"
                                                                                                                            }),
                                                                                                                        campaignModeSummary(campaign)
                                                                                                                      ],
                                                                                                                      className: "text-xs text-gray-600 truncate leading-snug",
                                                                                                                      title: campaignModeSummary(campaign)
                                                                                                                    })
                                                                                                              ],
                                                                                                              className: "mt-1 space-y-0.5"
                                                                                                            })
                                                                                                      ],
                                                                                                      className: "min-w-0 flex-1"
                                                                                                    })
                                                                                              ],
                                                                                              className: "flex items-center gap-3 min-w-0 flex-1 lg:max-w-[45%]"
                                                                                            }),
                                                                                        JsxRuntime.jsx("div", {
                                                                                              children: renderTriggerSummary(campaign),
                                                                                              className: "flex w-full min-w-0 lg:max-w-md lg:mx-auto flex-col items-center justify-center overflow-x-auto lg:overflow-visible lg:flex-shrink-0"
                                                                                            }),
                                                                                        JsxRuntime.jsx("div", {
                                                                                              children: JsxRuntime.jsxs("div", {
                                                                                                    children: [
                                                                                                      JsxRuntime.jsx("a", {
                                                                                                            children: JsxRuntime.jsx("button", {
                                                                                                                  children: "Dashboard",
                                                                                                                  className: "inline-flex items-center gap-2 px-3 py-2 rounded-xl border border-purple-300 text-purple-700 bg-white hover:bg-purple-50 text-xs font-semibold transition"
                                                                                                                }),
                                                                                                            href: "/campaigns/" + (String(Campaign$ReactHooksTemplate.id(campaign)) + "/dashboard")
                                                                                                          }),
                                                                                                      JsxRuntime.jsx("a", {
                                                                                                            children: JsxRuntime.jsx("button", {
                                                                                                                  children: "Distributions",
                                                                                                                  className: "inline-flex items-center gap-2 px-3 py-2 rounded-xl border border-blue-200 text-blue-700 bg-white hover:bg-blue-50 text-xs font-semibold transition"
                                                                                                                }),
                                                                                                            href: "/campaigns/" + (String(Campaign$ReactHooksTemplate.id(campaign)) + "/distributions")
                                                                                                          }),
                                                                                                      JsxRuntime.jsx("a", {
                                                                                                            children: JsxRuntime.jsxs("button", {
                                                                                                                  children: [
                                                                                                                    JsxRuntime.jsx("img", {
                                                                                                                          className: "h-14-px",
                                                                                                                          src: Image$ReactHooksTemplate.cogTransparent
                                                                                                                        }),
                                                                                                                    "Configuration"
                                                                                                                  ],
                                                                                                                  className: "inline-flex items-center gap-2 px-3 py-2 rounded-xl border border-gray-300 text-darkcharcoal bg-white hover:bg-ghostwhiteblue hover:border-pigmentblue hover:text-pigmentblue text-xs font-semibold transition",
                                                                                                                  title: "Open campaign configuration"
                                                                                                                }),
                                                                                                            href: "/campaigns/" + (String(Campaign$ReactHooksTemplate.id(campaign)) + "/dashboard?configuration=open")
                                                                                                          }),
                                                                                                      JsxRuntime.jsx("button", {
                                                                                                            children: JsxRuntime.jsx("img", {
                                                                                                                  className: "h-14-px",
                                                                                                                  src: Image$ReactHooksTemplate.edit
                                                                                                                }),
                                                                                                            className: "p-2 rounded-xl border border-gray-200 bg-white hover:bg-gray-50 text-gray-600 transition",
                                                                                                            title: "Edit campaign",
                                                                                                            onClick: (function (param) {
                                                                                                                Curry._1(dispatch, {
                                                                                                                      TAG: "SetOutsideClick",
                                                                                                                      _0: true
                                                                                                                    });
                                                                                                                Curry._1(dispatch, {
                                                                                                                      TAG: "SetCampaign",
                                                                                                                      _0: Caml_option.some(campaign)
                                                                                                                    });
                                                                                                                Curry._1(dispatch, {
                                                                                                                      TAG: "SetFormView",
                                                                                                                      _0: {
                                                                                                                        TAG: "Edit",
                                                                                                                        _0: campaign
                                                                                                                      }
                                                                                                                    });
                                                                                                                Curry._1(dispatch, "ToggleCampaignModal");
                                                                                                              })
                                                                                                          })
                                                                                                    ],
                                                                                                    className: "flex flex-wrap items-center gap-2 lg:justify-end w-full"
                                                                                                  }),
                                                                                              className: "flex flex-col items-start lg:items-end gap-2 lg:w-[360px] lg:flex-shrink-0"
                                                                                            })
                                                                                      ],
                                                                                      className: "px-4 py-3 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3 lg:gap-4"
                                                                                    }),
                                                                                className: "group relative rounded-2xl border border-gray-200 bg-white border-l-4 shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden " + cardAccent(index)
                                                                              }, String(Campaign$ReactHooksTemplate.id(campaign)));
                                                                  }))),
                                                        className: "flex flex-col gap-6"
                                                      }),
                                                  className: "rounded-2xl bg-gray-50 border border-gray-100 p-5 sm:p-7 lg:p-8 shadow-inner"
                                                }) : JsxRuntime.jsx("div", {
                                                  children: "No campaigns found",
                                                  className: "py-12 text-center text-gray-500 border border-dashed border-gray-300 rounded-xl"
                                                }),
                                          className: "px-4 sm:px-6 lg:px-8 pb-8 pt-2"
                                        })
                                  ],
                                  className: "bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
                                }),
                            state.campaignChangeModalToggle ? JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx(CampaignForm$ReactHooksTemplate.make, {
                                                      toggleCampaign: toggleCampaign,
                                                      toggleModal: (function (param) {
                                                          Curry._1(dispatch, "ToggleCampaignModal");
                                                        }),
                                                      selectedCampaign: state.selectedCampaign
                                                    }),
                                                className: "border-t border-gray-200 text-base font-medium h-full"
                                              }),
                                          className: "bg-white modal-campaign-form z-10 shadow relative border border-gray-300 border-b-0 pointer-events-auto"
                                        }),
                                    className: "w-screen z-10 disabled-wrapper fixed inset-0 flex justify-center items-center"
                                  }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                          ],
                          className: "max-w-[1600px] mx-auto px-4 sm:px-6 py-6"
                        }))
            });
}

var make = CampaignList;

exports.initialState = initialState;
exports.reducer = reducer;
exports.searchPlaceholder = searchPlaceholder;
exports.make = make;
/* react Not a pure module */
